export const THEMES = ['purple', 'ocean', 'forest', 'sunset', 'rose', 'dark'];

export const THEME_LABELS = {
  purple: 'Purple (default)',
  ocean:  'Ocean',
  forest: 'Forest',
  sunset: 'Sunset',
  rose:   'Rose',
  dark:   'Dark',
};

export function applyTheme(name) {
  const safe = THEMES.includes(name) ? name : 'purple';
  document.documentElement.setAttribute('data-theme', safe);
}

// Returns the effective theme given the 3-tier cascade.
// Pass null/undefined/'' to skip a tier.
export function resolveTheme(branchTheme, userTheme, sessionTheme) {
  return sessionTheme || userTheme || branchTheme || 'purple';
}
